import { useState, useEffect } from 'react';

const useDeviceType = () => {
    const [isDesktop, setIsDesktop] = useState(window.innerWidth > 733);

    useEffect(() => {
        const handleResize = () => setIsDesktop(window.innerWidth >= 733);

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return isDesktop;
};

export default useDeviceType;
